import {
    ReactElement,
    useRef,
} from 'react';

import {Stack,} from '@mantine/core';

import {useCodePipelines} from '../hooks/useCodePipelines.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {useCodePipelinesSelection} from '../hooks/useCodePipelinesSelection.ts';
import {useVerifiedPermissions} from "../../../../hooks/useVerifiedPermissions.ts";
import {useCodePipelinesSearch} from "../hooks/useCodePipelinesSearch.ts";
import {useCodePipelinesTableColumns} from "../hooks/useCodePipelinesTableColumns.tsx";
import {rbacActions} from "../../../../config/rbac/actions.ts";
import {DataTableColumn} from "mantine-datatable";
import {DataTableTokenPagination} from "../../../../components/DataTableTokenPagination";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {allowedActions} = useVerifiedPermissions()

    const {
        visibleItems: records,
        loading,
        nextToken,
        fetchNextPage,
    } = useCodePipelines();

    const {
        columns,
    } = useCodePipelinesTableColumns();

    const {
        handleFilterByKeyword,
    } = useCodePipelinesSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = useCodePipelinesSelection();

    let selectedRecords = [] as any[];
    if (allowedActions.includes(rbacActions.DeleteCodePipeline)) {
        selectedRecords = records.filter(record => selection[record.name])
    }

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={10}
                handleItemsPerPageChange={() => {}}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach((item: any) => {
                        handleRowSelection(item.name, true)
                    })
                }}
                fetching={loading}
                idAccessor="name"
                onScrollToBottom={() => fetchNextPage()}
                scrollViewportRef={scrollViewportRef}
            />

            <DataTableTokenPagination
                totalCount={records.length.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchNextPage}
            />
        </Stack>
    );
};
